import type { CalendarQueryInput, CalendarQueryResult } from '@vivport/backend/types';
import { httpClient } from './http-client';

export async function queryCalendar(input: CalendarQueryInput): Promise<CalendarQueryResult> {
  return httpClient.post<CalendarQueryResult, CalendarQueryInput>('/protected/calendar/query', input);
}
